import React, { ReactElement } from 'react';

import { PageProperties } from '../../../types';
import { Accordion } from '../../../components/Accordion/Accordion';
import { trackEvent } from '../../../modules/analytics';
import { FAQ_TOGGLED } from '../../../constants/analytics';
import { useRouter } from 'next/router';
import { getAbsoluteUrl } from '@/helpers/formatUrl';

interface VerticalFAQProps {
  pageProperties: PageProperties;
}

export function VerticalFAQ({
  pageProperties,
}: VerticalFAQProps): ReactElement {
  const router = useRouter();
  const { pageContent } = pageProperties;
  const { faqComponentContent } = pageContent;

  if (!faqComponentContent?.length) return null;

  const heading = getHeading();

  const items = faqComponentContent.map(item => ({
    heading: item.question,
    headingTag: 'h3' as 'h1' | 'h2' | 'h3' | 'h4',
    body: item.answer,
  }));

  return (
    <Accordion
      heading={heading}
      items={items}
      displayBackgroundElements={true}
      onToggleItem={(heading, expanded) => {
        trackEvent(FAQ_TOGGLED, {
          faqTitle: heading,
          type: expanded ? 'expand' : 'collapse',
          currentPage: getAbsoluteUrl(router.asPath),
        });
      }}
      interactive={false}
      defaultExpanded={true}
    />
  );
}

const getHeading = () => {
  return 'Frequently asked questions about Togather';
};
